// themeButton
import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles(() => ({
  themeButton: {
    position: "relative",
    transformStyle: "preserve-3d",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderColor: "black",
    borderWidth: "0px", 
    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.5)",
  },

  heading: {
    "&..css-tp1jng-MuiCardHeader-root": {
      padding: "14px 24px 4px 25px",
    },
  },
}));
